import { Competition, Endpoints, TFile } from '@brg/api';
import { FC, memo, useEffect, useRef, useState } from 'react';
import { ImageWrapper, Image } from './styles';
import { useResizedImageEnhanced } from "../../hooks/useResizedImageEnhanced";
import { ImagePlaceholderIcon } from 'shared/assets/32/ImagePlaceholderIcon';
import { AppTester } from 'supporting';
import { useRouteMatch } from 'react-router-dom';
import { RatingImgGenerate } from 'shared/pages/opencallsPage/GetCompetitionItem/components/RatingImgGenerate';
import styled from 'styled-components';

type PropsT = {
    files?: TFile[];
    className?: string;
    onClick?: () => void;
    fixedSize?: any;
    placeholder?: string;
    showDefaultPlaceholder?: boolean;
    showEmptyPlaceholder?: boolean;
    showOriginal?: boolean;
    competition?: Competition<'Local'>;
    alt?: any;
};
const FadeInImage = styled(Image)`
    transition: opacity 0.2s ease-in-out, filter 0.2s ease-in-out;
    opacity: 0;
    &.loaded {
        opacity: 1;
    }
`;

const ResizedImageEnhanced: FC<PropsT> = ({
    className,
    files,
    onClick,
    fixedSize,
    placeholder,
    showDefaultPlaceholder,
    showEmptyPlaceholder,
    showOriginal,
    competition,
    alt,
    ...rest }) => {

    const [image, containerRef] = useResizedImageEnhanced(files, fixedSize, showOriginal);
    const isCompetition = AppTester.isCompetition();
    const isCompetitions = useRouteMatch(['/awards']);
    const isCompetitionPage = useRouteMatch(['/competition']);
    const [containerWidth, setContainerWidth] = useState(0)
    const imageRef = useRef<HTMLImageElement>(null)
    useEffect(() => {
        //@ts-ignore
        if (!containerRef.current) return;

        const observer = new ResizeObserver((entries) => {
            setContainerWidth(entries[0].contentRect.width);
        });
        //@ts-ignore
        observer.observe(containerRef.current);

        return () => observer.disconnect();
    }, []);
    //@ts-ignore
    if (competition && competition?.isRating && !competition?.titleImages?.length) {
        return (
            <RatingImgGenerate competition={competition} isCompetitionPage={!!isCompetitionPage} />
        )
    }

    const handleLoad = () => {
        if (imageRef.current) {
            imageRef.current.classList.add('loaded')
        }
    }


    return (
        <ImageWrapper isDefaultPlaceholder={showEmptyPlaceholder || showDefaultPlaceholder} ref={containerRef} isCompetition={isCompetition || !!isCompetitions} className={className} onClick={onClick}>
            {image && (
                <FadeInImage
                    ref={imageRef}
                    src={`${Endpoints.files}/${image?.url}`}
                    {...rest}
                    alt={alt ?? ''}
                    title={alt ?? ''}
                    loading="lazy"
                    onLoad={handleLoad}
                />
            )}
            {!image && !showDefaultPlaceholder && <Image src={placeholder} {...rest} />}
            {!image && showDefaultPlaceholder && <ImagePlaceholderIcon />}
        </ImageWrapper>
    );
};

export default memo(ResizedImageEnhanced);
import { Competition, Endpoints, TFile } from '@brg/api';
import { FC, memo, useEffect, useRef, useState } from 'react';
import { ImageWrapper, Image } from './styles';
import { useResizedImageEnhanced } from "../../hooks/useResizedImageEnhanced";
import { ImagePlaceholderIcon } from 'shared/assets/32/ImagePlaceholderIcon';
import { AppTester } from 'supporting';
import { useRouteMatch } from 'react-router-dom';
import { RatingImgGenerate } from 'shared/pages/opencallsPage/GetCompetitionItem/components/RatingImgGenerate';
import styled from 'styled-components';

type PropsT = {
    files?: TFile[];
    className?: string;
    onClick?: () => void;
    fixedSize?: any;
    placeholder?: string;
    showDefaultPlaceholder?: boolean;
    showEmptyPlaceholder?: boolean;
    showOriginal?: boolean;
    competition?: Competition<'Local'>;
    alt?: any;
};
const FadeInImage = styled(Image)`
    transition: opacity 0.2s ease-in-out, filter 0.2s ease-in-out;
    opacity: 0;
    &.loaded {
        opacity: 1;
    }
`;

const ResizedImageEnhanced: FC<PropsT> = ({
    className,
    files,
    onClick,
    fixedSize,
    placeholder,
    showDefaultPlaceholder,
    showEmptyPlaceholder,
    showOriginal,
    competition,
    alt,
    ...rest }) => {

    const [image, containerRef] = useResizedImageEnhanced(files, fixedSize, showOriginal);
    const isCompetition = AppTester.isCompetition();
    const isCompetitions = useRouteMatch(['/awards']);
    const isCompetitionPage = useRouteMatch(['/competition']);
    const [containerWidth, setContainerWidth] = useState(0)
    const imageRef = useRef<HTMLImageElement>(null)
    useEffect(() => {
        //@ts-ignore
        if (!containerRef.current) return;

        const observer = new ResizeObserver((entries) => {
            setContainerWidth(entries[0].contentRect.width);
        });
        //@ts-ignore
        observer.observe(containerRef.current);

        return () => observer.disconnect();
    }, []);
    //@ts-ignore
    if (competition && competition?.isRating && !competition?.titleImages?.length) {
        return (
            <RatingImgGenerate competition={competition} isCompetitionPage={!!isCompetitionPage} />
        )
    }

    const handleLoad = () => {
        if (imageRef.current) {
            imageRef.current.classList.add('loaded')
        }
    }


    return (
        <ImageWrapper isDefaultPlaceholder={showEmptyPlaceholder || showDefaultPlaceholder} ref={containerRef} isCompetition={isCompetition || !!isCompetitions} className={className} onClick={onClick}>
            {image && (
                <FadeInImage
                    ref={imageRef}
                    src={`${Endpoints.files}/${image?.url}`}
                    {...rest}
                    alt={alt ?? ''}
                    title={alt ?? ''}
                    loading="lazy"
                    onLoad={handleLoad}
                />
            )}
            {!image && !showDefaultPlaceholder && <Image src={placeholder} {...rest} />}
            {!image && showDefaultPlaceholder && <ImagePlaceholderIcon />}
        </ImageWrapper>
    );
};

export default memo(ResizedImageEnhanced);
